import React from 'react';
import * as mobxReact from 'mobx-react';
import * as mobx from 'mobx';
import { injectIntl, IntlShape } from 'react-intl';
import PlanningNotesFormVM from './planning-notes-form.viewmodel';
import './planning-notes-form.scss';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { FormField } from '../../global/form/form-field/form-field';
import { RichTextEditor } from '../../global/rich-text-editor';
import { DefaultCloseSubWindowButton } from '../../global/sub-window/common/common-close-sub-window-buttons';
import { APPLY_TEXT, CANCEL_TEXT, loadingText } from '../../../constants/common-labels.constants';

interface IPlanningNotesFormPresentation {
    vm: PlanningNotesFormVM;
    intl: IntlShape;
}

const PlanningNotesFormPresentation = injectIntl(mobxReact.observer(({ vm, intl }: IPlanningNotesFormPresentation) => {

    if (vm.isLoading) {
        return <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form planning-notes-form'>
                    { loadingText() }
                </div>
            }
        />;
    }

    return (
        <CommonPopupBodyFooterLayout
            body={(
                <form className='oe-form planning-notes-form' onSubmit={vm.formSubmitAction}>
                    <div className='oe-form__body'>
                        <FormField label={intl.formatMessage({
                            id: 'oe.common.planningNotes',
                            defaultMessage: 'Planning Notes',
                            description: 'Label text'
                        })}>
                            <RichTextEditor
                                id='event-planning-notes'
                                value={vm.eventInfo.planningNotes}
                                className={'planning-notes-editor'}
                                onChange={mobx.action((_, editor) => {
                                    vm.eventInfo.planningNotes = editor.getData();
                                })}
                                validationError={vm.getPlanningNotesLengthError()}
                            />
                        </FormField>
                    </div>
                </form>
            )}
            footer={
                <>
                    {vm.isSaving && <div>
                        {intl.formatMessage({
                            id: 'oe.control.planningNotesIsBeingSaved',
                            description: 'Placeholder about saving planning notes',
                            defaultMessage: 'Planning Notes is being saved, please wait...',
                        })}
                    </div>}
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(APPLY_TEXT)}
                            onClick={vm.formSubmitAction}
                            modifier={['fat', 'confirm-safe']}
                            disabled={vm.getPlanningNotesError() || vm.isSaving}
                        />
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(CANCEL_TEXT)}
                            onClick={() => {
                                vm.trackEventNotesMixPanel(false);
                                return true;
                            }}
                        />
                    </div>
                </>
            }
        />
    );
}));

export { PlanningNotesFormPresentation };
